import api from "./api"

export const login = async (username, password) => {
    try {

        const response = await api.post("/auth/login", {
            username,
            password
        })
        const { token, id, role, name } = response.data
        if (token) {
            localStorage.setItem("token", token)
        }
        if (id) {
            localStorage.setItem("investorId", id)
        }
        if (role){
            localStorage.setItem("role", role)
        }
        if (name) {
            localStorage.setItem("investorName", name)
        }
        return response.data
    } catch (error) {
        console.error("Erro no login:", error)
        throw error
    }
}

export const logout = () => {
    clearStorage()
}

export const getToken = () => {
    return localStorage.getItem("token")
}

export const getInvestorId = () => {
    return localStorage.getItem("investorId")
}

export const getRole = () => {
    return localStorage.getItem("role")
}

export const getInvestorName = () => {
    return localStorage.getItem("investorName") || "Você"
}

export const clearStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("investorId");
    localStorage.removeItem("role");
}

export const isAuthenticated = () => {
    return !!localStorage.getItem("token")
}